export const loginAdmin = (id, password) => {
  if (id === "admin" && password === "12345") {
    sessionStorage.setItem("admin", JSON.stringify({ id }));
    return true;
  }
  return false;
};

export const isAdminLoggedIn = () => {
  return sessionStorage.getItem("admin") !== null;
};

export const logoutAdmin = () => {
  sessionStorage.removeItem("admin");
};